import { defineComponent, PropType, ref } from 'vue';
import { BudgetForm } from '@/store/project/project.model';
import BudgetFormComponent from '@/components/project/create/createComponents/budgetForm/BudgetForm.vue';

export default defineComponent({
  name: 'BudgetTabComponent',
  components: {
    BudgetFormComponent
  },
  emits: [
    'next'
  ],
  props: {
    budgets: {
      type: Object as PropType<BudgetForm[]>,
      required: true,
    }
  },
  setup: (_, context) => {
    const budgetForm = ref<InstanceType<typeof BudgetFormComponent>>();

    const nextClick = () => {
      budgetForm.value?.submitForm();
    };

    const validated = (budgetsData: BudgetForm[]) => {
      context.emit('next', budgetsData);
    };

    return {
      budgetForm,
      nextClick,
      validated,
    };
  },
});
